import ajax from '../utils/fetch/ajax';
import invoke from '../utils/fp/invoke';
import memoize from '../utils/fp/memoize';
import fetchJSON from '../utils/fetch/fetchJSON';
import getDefaultMember from '../sem/storage-manager/getDefaultMember';
import setDefaultProfileDob from '../sem/storage-manager/setDefaultProfileDob';
import config from './config';
import memberType from './memberType';

const url = config.getFPL;

/**
 * Makes a request to the GetFPL service with a Promise
 *
 * @param {Object} data Payload for GetFPL endpoint
 * @returns {Promise} The request promise
 */
function getFPLPromise(data) {
  return fetchJSON({
    url,
    data,
  })
    .catch((error) => {
      rg4js('send', {
        error,
        customData: [
          {
            url,
            data,
          },
        ],
      });
      return {
        status: 404,
      };
    });
}

/**
 * Makes a request to the GetFPL service Asynchronously
 *
 * @param {Object} {data, callback} Payload required by the endpoint
 * @returns {XMLHttpRequest} The request object
 */
function getFPLSync({data, callback}) {
  const callbackFn = invoke(callback);
  try {
    return ajax(url, {
      data,
      async: false,
      onload: callbackFn,
    });
  } catch (e) {
    rg4js('send', {
      error: e,
      customData: [
        {
          url,
          data,
        },
      ],
    });

    return callbackFn();
  }
}

const getFPLAsync = memoize(getFPLPromise);

/**
 * Gets the Federal Poverty Level of the applicant
 * @see https://github.com/healthcarecom/plans-service#fpl-check
 *
 * @param {Object} hcStorage hcStorage applicant object
 * @param {Function} callback callback to execute.  Chain a then() is preferred.
 * @returns {Promise}
 */
function getFPL(hcStorage, callback) {
  const applicant = hcStorage.members.find(member => member.type === memberType.primary);
  const holder = applicant ? {...applicant} : Object.assign(getDefaultMember(), {
    tobacco: 'n',
    phoneIsMobile: 'n',
    gender: 'm',
  });

  if (!holder.dob) {
    setDefaultProfileDob(holder, true);
  }

  const incomeStr = (hcStorage.household.income && hcStorage.household.income.toString()) || '0';
  const periodIdx = incomeStr.indexOf('.');
  const decimalEndIdx = ((periodIdx > -1 && periodIdx) || incomeStr.length);
  const income = parseInt(incomeStr.substring(0, decimalEndIdx).replace(/\D/g, ''), 10);

  const data = {
    HouseHoldSize: hcStorage.household.size || 1,
    State: hcStorage.location.state_acronym,
    HouseIncome: income,
  };

  if (callback) {
    return getFPLSync({data, callback});
  }

  return getFPLAsync(data);
}

export default getFPL;
